import React from 'react';

// Every form/dialog in the admin was hand-rolling this same fixed-overlay +
// centered-box shell with slightly different widths and paddings. One place to
// get the chrome right (overlay, sizing, header, scroll behavior).
const Modal = ({ title, description, onClose, children, wide = false }) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 p-4 overflow-y-auto">
        <div className={`w-full ${wide ? 'max-w-2xl' : 'max-w-md'} bg-base-100 rounded-lg shadow-xl my-8`}>
            {(title || onClose) && (
                <div className="flex items-start justify-between gap-4 px-5 pt-5">
                    <div>
                        {title && <h2 className="text-base font-semibold">{title}</h2>}
                        {description && <p className="text-xs text-base-content/60 mt-0.5">{description}</p>}
                    </div>
                    {onClose && (
                        <button
                            type="button"
                            onClick={onClose}
                            className="btn btn-ghost btn-xs btn-circle text-base-content/50"
                            aria-label="Close"
                        >
                            ✕
                        </button>
                    )}
                </div>
            )}
            <div className="p-5">{children}</div>
        </div>
    </div>
);

export default Modal;
